var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelectLasso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: "1.5px",
    transform: "scale(0.8)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,22a5,5,0,0,1-2-4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,17.84A13.06,13.06,0,0,1,12,18a11.93,11.93,0,0,1-5-1.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.34,14A6.8,6.8,0,0,1,2,10C2,5.58,6.48,2,12,2s10,3.58,10,8a7.19,7.19,0,0,1-2.6,5.38"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.33,22h-.09a.35.35,0,0,1-.24-.32v-10a.34.34,0,0,1,.33-.34.32.32,0,0,1,.21.08l7.34,6a.33.33,0,0,1-.21.59H17.18l-2.57,3.85A.35.35,0,0,1,14.33,22Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLasso);
export default __webpack_public_path__ + "static/media/select_lasso.4e8ec7cd5ffa0fba5e959596b6f40b26.svg";
export { ForwardRef as ReactComponent };